import actionTypes from './testSiteStatusActionTypes';
import type { ProgressStatus } from '@/constants';

export const setTestSiteStatus = (testSiteStatus: ProgressStatus) => ({
  type: actionTypes.SET_TEST_SITE_STATUS,
  testSiteStatus,
});
